import React, { useState } from 'react';
import { Card } from './ui/card';

// Optimiert URL für Unsplash und Pexels
const optimizeUnsplashUrl = (url) => {
  if (url.includes('unsplash.com')) return `${url}?w=600&q=80&auto=format&fit=crop`;
  return url; // Pexels & andere bereits mit Parametern
};

const GalleryImage = ({ image }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  return (
    <Card
      className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 border-0"
    >
      <div className="relative h-72 overflow-hidden bg-gray-100">
        {/* Lade-Skeleton */}
        {!isLoaded && (
          <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-pulse flex items-center justify-center">
            <div className="w-12 h-12 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
          </div>
        )}
        
        <img
          src={optimizeUnsplashUrl(image.url)}
          alt={image.altText || `${image.brand} ${image.model} bei Autohaus Wilke Magdeburg`}
          loading="lazy"
          onLoad={() => setIsLoaded(true)}
          className={`w-full h-full object-cover transition-all duration-700 group-hover:scale-110 ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        
        {/* Brand Badge */}
        <div 
          className="absolute top-4 right-4 px-4 py-2 rounded-full text-white font-semibold text-sm shadow-lg backdrop-blur-sm"
          style={{ backgroundColor: `${image.color}CC` }}
        >
          {image.brand}
        </div>

        {/* Model Info */}
        <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
          <h3 className="text-2xl font-bold text-white mb-2">
            {image.brand} {image.model}
          </h3>
          <div 
            className="w-12 h-1 rounded-full"
            style={{ backgroundColor: image.color }}
          ></div>
        </div>
      </div>

      {/* Accent Border */}
      <div
        className="absolute top-0 left-0 right-0 h-1 transition-all duration-500 group-hover:h-2"
        style={{ backgroundColor: image.color }}
      ></div>
    </Card>
  );
};

export const VehicleGallery = () => {
  const galleryImages = [
    {
      id: 1,
      url: '/brand-images/nissan-qashqai-2026.png',
      brand: 'Nissan',
      model: 'Qashqai',
      color: '#C3002F',
      altText: 'Nissan Qashqai 2026 SUV bei Autohaus Wilke Magdeburg'
    },
    {
      id: 2,
      url: '/brand-images/mazda-cx5-2026.jpg',
      brand: 'Mazda',
      model: 'CX-5',
      color: '#000000',
      altText: 'Mazda CX-5 2026 SUV kaufen in Magdeburg - Autohaus Wilke'
    },
    {
      id: 3,
      url: '/brand-images/nissan-leaf-2026.jpg',
      brand: 'Nissan',
      model: 'Leaf',
      color: '#C3002F',
      altText: 'Nissan Leaf 2026 Elektro-Crossover - Autohaus Wilke Magdeburg'
    },
    {
      id: 4,
      url: '/brand-images/mazda-cx30.jpg',
      brand: 'Mazda',
      model: 'CX-30',
      color: '#000000',
      altText: 'Mazda CX-30 2026 Crossover Neuwagen bei Autohaus Wilke'
    },
    {
      id: 5,
      url: '/brand-images/nissan-juke-2026.png',
      brand: 'Nissan',
      model: 'Juke',
      color: '#C3002F',
      altText: 'Nissan Juke 2026 - Autohaus Wilke Magdeburg'
    },
    {
      id: 6,
      url: '/brand-images/mazda-cx60-2026.jpg',
      brand: 'Mazda',
      model: 'CX-60',
      color: '#000000',
      altText: 'Mazda CX-60 2026 Premium SUV kaufen - Autohaus Wilke Magdeburg'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Unsere Fahrzeugwelt
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Entdecken Sie die Vielfalt und Eleganz unserer Nissan und Mazda Modelle
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <GalleryImage key={image.id} image={image} />
          ))}
        </div>
      </div>
    </section>
  );
};
